import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Header = ({ onRules, onGameList, onSettings, onRestart, title }) => {
  const { t } = useLanguage();
  
  return (
    <div className="title-container">
      <div className="left-buttons">
        <button className="text-button" onClick={onGameList}>
          {t('gameList')}
        </button>
        <button className="text-button" onClick={onRules}>
          {t('rules')}
        </button>
      </div>
      <h1>{title}</h1>
      <div className="right-buttons">
        <button className="text-button" onClick={onSettings}>
          <svg 
            className="settings-icon" 
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 15.5A3.5 3.5 0 0 1 8.5 12 3.5 3.5 0 0 1 12 8.5a3.5 3.5 0 0 1 3.5 3.5 3.5 3.5 0 0 1-3.5 3.5m7.43-2.53c.04-.32.07-.65.07-.97 0-.32-.03-.65-.07-.97l2.11-1.63c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.31-.61-.22l-2.49 1c-.52-.39-1.06-.73-1.69-.98l-.37-2.65c-.04-.24-.25-.42-.5-.42h-4c-.25 0-.46.18-.5.42l-.37 2.65c-.63.25-1.17.59-1.69.98l-2.49-1c-.22-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64L4.57 12c-.04.32-.07.65-.07.97 0 .32.03.65.07.97l-2.11 1.63c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.31.61.22l2.49-1c.52.39 1.06.73 1.69.98l.37 2.65c.04.24.25.42.5.42h4c.25 0 .46-.18.5-.42l.37-2.65c.63-.25 1.17-.59 1.69-.98l2.49 1c.22.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.63z"/>
          </svg>
        </button>
        <button className="text-button" onClick={onRestart}>
          {t('restart')}
        </button>
      </div>
    </div>
  );
};

export default Header; 